export default __webpack_public_path__ + "static/13-9149f7d652404a461ad20f2db73c9b71.webp";